export const ANALYTICS_KEY = "SCK_AF62DC366C7CC8AF11D418";
export const BASEURL2 = "https://v4ses32uz7.eu-west-1.awsapprunner.com/v2/";
export const SAVE_CHAT =
  "https://udbd6cbymx.eu-west-1.awsapprunner.com/v1/api/chatbots/save-log";
export const ASSISTANT_ID = "AST_55CBABB856816CC";

export const META_DATA = {
  assistant_id: ASSISTANT_ID,
};

export const DEPT = [
  {
    name: "Customer Service",
    phone: "+2348110248204",
    email: "sotom.horsfall@analyticsintelligence.com",
  },
];

export const EMAIL_SERVICE =
  "https://zd7if8kc4q.eu-west-1.awsapprunner.com/api/email/";

export const INTERNAL_RECIPIENTS = [
  "omolara.oseni@analyticsintelligence.com",
  "info@analyticsintelligence.com",
];
